import { ca } from '@cian/analytics';

export const sendKpnGuideLinkClick = () => {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'FAQ_kpn_guide_link',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
  });
};

export const sendKpnGuideLinkShowed = () => {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'FAQ_kpn_guide_link',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
  });
};
